import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Similar to swatch but presents checkbox icon instead
 */
@Component({
    standalone: false,
    selector: 'icms-loader',
    template: `<icms-icon [dfs]="'d:block'" [icon]="'refresh'" class="_loader"></icms-icon>`,
    styleUrls: ['./icms-loader.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsLoaderComponent {}
